import type React from 'react';
import type { IconProps } from 'types/icon';

const AddToBasket: React.FC<IconProps> = ({
  size = '24',
  color = 'currentColor',
  ...attributes
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...attributes}
    >
      <path
        d="M15.5615 5.7502H17.8726C18.4934 5.7502 18.9642 6.30993 18.8578 6.92154L18.5401 8.74867M15.5615 5.7502H4.06154M15.5615 5.7502L13.5615 0.750199M4.06154 5.7502H1.75047C1.12967 5.7502 0.658888 6.30993 0.765255 6.92154L2.27331 15.5929C2.43992 16.5509 3.27138 17.2502 4.24374 17.2502H8.06154M4.06154 5.7502L6.06154 0.750199M11.5615 15.0002H14.8115M14.8115 15.0002H18.0615M14.8115 15.0002V11.7502M14.8115 15.0002V18.2502"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default AddToBasket;
